import { useVisit } from '../VisitContext';
import { ChevronLeft } from 'lucide-react';
import { Button } from '~/shared/components/buttons/Button';

export function NavigatePreviousButton() {
	const { navigateToPreviousItem } = useVisit();
	return <Button type="button" appearance="outline" onClick={navigateToPreviousItem} Icon={ChevronLeft} label="Previous" />;
}
